import {fontHeading} from '../font';
import eot from './Campton-SemiBold.eot';
import svg from './Campton-SemiBold.svg';
import ttf from './Campton-SemiBold.ttf';
import woff from './Campton-SemiBold.woff';
import woff2 from './Campton-SemiBold.woff2';

export default `@font-face {
  font-family: '${fontHeading}';
  src: url('${eot}');
  src: url('${eot}?#iefix') format('embedded-opentype'),
       url('${svg}#Campton-SemiBold') format('svg'),
       url('${ttf}') format('truetype'),
       url('${woff}') format('woff'),
       url('${woff2}') format('woff2');
  font-weight: normal;
  font-style: bold;
  font-display: fallback;
}`